import React, { useContext } from 'react'
import { StyleSheet, Text, View } from 'react-native';
import { RiFireFill } from "react-icons/ri";
import { useTranslation } from 'react-i18next';

import {
  contentWrapTransColor, blackColor,
  bigFontPc, bigFontSp, fontPc, fontSp,
} from '../../../../../style/css/CmnStyle';
import { hpContext } from '../../../HPContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';

function HpContentHowto(props) {
  const { t, i18n } = useTranslation();

  const isWide = useContext(hpContext).isWide;

  const windowDimensions = useContext(hpContext).windowDimensions;
  const windowWidth = windowDimensions.width;
  const windowHeight = windowDimensions.height;


  const styles = StyleSheet.create({
    container: {
      backgroundColor: 'transparent',
      paddingVertical: isWide? windowHeight*0.15 : windowHeight*0.1,
      paddingHorizontal: isWide? windowWidth*0.2 : 20,
    },
    mainWrap: {
      backgroundColor: contentWrapTransColor,
      paddingVertical: isWide? '5%' : '10%',
      paddingHorizontal: isWide? '10%' : '5%',
      borderRadius: 50,
    },

    title: {
      color: blackColor,
      fontSize: isWide? bigFontPc : bigFontSp,
      fontWeight: 'bold',
      textAlign: 'center',
      textDecorationColor: blackColor,
      textDecorationLine: 'underline',
      marginBottom: isWide? 20 : 10,
    },

    howto: {
      flexDirection: 'row',
      alignItems: 'center',
      marginVertical: isWide? 20 : 13,
    },
    howtoIcon: {
      marginRight: isWide? 20 : 10,
    },
    howtoTxt: {
      color: blackColor,
      fontSize: isWide? fontPc : fontSp,
      lineHeight: isWide? '2rem' : '1.3rem',
      width: '100%',
    },
  });


  return (
    <View id='howto' style={styles.container}>
    <FadeinWrap loop={true}>
    <View style={styles.mainWrap}>

      <Text style={styles.title}>{t('top.howto.title')}</Text>

      <View style={styles.howto}>
        <RiFireFill size={isWide? '3.5em' : '2em'} color={blackColor} style={styles.howtoIcon} />
        <Text style={styles.howtoTxt}>{t('top.howto.content1')}</Text>
      </View>

      <View style={styles.howto}>
        <RiFireFill size={isWide? '3.5em' : '2em'} color={blackColor} style={styles.howtoIcon} />
        <Text style={styles.howtoTxt}>{t('top.howto.content2')}</Text>
      </View>

      <View style={styles.howto}>
        <RiFireFill size={isWide? '3.5em' : '2em'} color={blackColor} style={styles.howtoIcon} />
        <Text style={styles.howtoTxt}>{t('top.howto.content3')}</Text>
      </View>

      <View style={styles.howto}>
        <RiFireFill size={isWide? '3.5em' : '2em'} color={blackColor} style={styles.howtoIcon} />
        <Text style={styles.howtoTxt}>{t('top.howto.content4')}</Text>
      </View>

    </View>
    </FadeinWrap>
    </View>
  );
}
export default HpContentHowto;
